import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PaymentSuccessModal from '../components/checkout/PaymentSuccessModal';
import {
  clearPendingCoursePayment,
  loadPendingCoursePayment,
  parsePaymentSuccessFromSearchParams,
  PaymentSuccessDetails,
} from '../types/paymentSuccess';

const PaymentSuccessPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [details, setDetails] = useState<PaymentSuccessDetails | null>(null);

  const parsedFromUrl = useMemo(
    () => parsePaymentSuccessFromSearchParams(searchParams),
    [searchParams]
  );

  useEffect(() => {
    const pending = loadPendingCoursePayment();
    const merged: PaymentSuccessDetails | null = parsedFromUrl
      ? {
          ...pending,
          ...parsedFromUrl,
          courseName: parsedFromUrl.courseName ?? pending?.courseName,
          amount: parsedFromUrl.amount || pending?.amount || 0,
        }
      : pending;

    if (merged?.courseId) {
      setDetails(merged);
      clearPendingCoursePayment();
      return;
    }

    navigate('/student-portal', { replace: true });
  }, [parsedFromUrl, navigate]);

  const handleClose = () => {
    if (details?.courseId) {
      navigate(`/course-player/${details.courseId}`, { replace: true });
      return;
    }
    navigate('/student-portal', { replace: true });
  };

  return (
    <div className="min-h-screen bg-gray-50" dir="rtl">
      <PaymentSuccessModal isOpen={!!details} onClose={handleClose} details={details} />
    </div>
  );
};

export default PaymentSuccessPage;
